import { useEffect } from "react";
import { useTheme } from "../contexts/ThemeContext.tsx";

/**
 * O design system novo (src/styles/design-system.css) usa tokens CSS
 * chaveados por [data-theme] no <html>. O app já controla dark/light via
 * ThemeContext (estado React, não prefers-color-scheme) — este hook só
 * espelha esse estado no atributo do DOM pra o CSS puro enxergar.
 */
export const useSyncThemeAttribute = () => {
  const { darkMode } = useTheme();

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", darkMode ? "dark" : "light");
  }, [darkMode]);
};
